// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__1j96l","header":"MergedInvoice_header__fHT7P"};